// removed by extract-text-webpack-plugin
module.exports = {"checkboxWrap":"qempo_Checkbox_checkboxWrap-2FWT1f3","acceptTerms":"qempo_Checkbox_acceptTerms-17br4pX","checkmark":"qempo_Checkbox_checkmark-35bssLb","content":"qempo_Checkbox_content-2EUdMYP","lightBlue":"qempo_Checkbox_lightBlue-1f-agdd","orange":"qempo_Checkbox_orange-1FIeuP1"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/Checkbox/Checkbox.scss
// module id = 334
// module chunks = 0